/*
  Cloudy Mattress - open the WillDesk chat from any button with [data-cm-open-chat],
  and auto-open it when the page URL has ?cm_chat=1 (used by the thank-you page button).

  IMPORTANT: confirm LAUNCHER_SELECTORS once on the live site.
  Open the store, wait for the WillDesk bubble, right-click it > Inspect,
  and put its id or class at the top of this list.
*/
(function () {
  var LAUNCHER_SELECTORS = [
    '.helpdesk-channel-start-btn',
    '[id*="willdesk" i] button',
    '[class*="willdesk" i] [class*="launcher" i]',
    '[class*="willdesk" i] button',
    '[id*="willdesk" i]'
  ];
  var FALLBACK_URL = '/pages/contact'; // used if the chat can't be found
  var WAIT_MS = 8000;

  function findLauncher() {
    for (var i = 0; i < LAUNCHER_SELECTORS.length; i++) {
      try {
        var el = document.querySelector(LAUNCHER_SELECTORS[i]);
        if (el && el.tagName !== 'IFRAME') return el;
      } catch (e) {}
    }
    return null;
  }

  function openChat(btn) {
    // The theme delays third-party scripts until the first interaction (snippets/custom.liquid).
    try { if (typeof window.loadJSscripts === 'function') window.loadJSscripts(); } catch (e) {}
    if (btn) btn.setAttribute('aria-busy', 'true');

    var started = Date.now();
    (function poll() {
      var launcher = findLauncher();
      if (launcher) {
        launcher.click();
        if (btn) btn.removeAttribute('aria-busy');
        return;
      }
      if (Date.now() - started > WAIT_MS) {
        if (btn) btn.removeAttribute('aria-busy');
        window.location.href = FALLBACK_URL;
        return;
      }
      setTimeout(poll, 250);
    })();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cm-open-chat]');
    if (!btn) return;
    e.preventDefault();
    openChat(btn);
  });

  if (/[?&]cm_chat=1\b/.test(window.location.search)) {
    window.addEventListener('load', function () { openChat(null); });
  }
})();
